
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { TWADialogsService } from '../_services/twa-dialogs.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class IsActiveGuard  {

    constructor(
        public router: Router,
        private authSvc: AuthenticationService,
        private dlgsSvc: TWADialogsService,
    ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    const api_key = localStorage.getItem('api_key');

    if (!api_key) {
        // Mostrar diálogo de sesión no válida
        this.dlgsSvc.confirm(
            'Sesión No Válida',
            'Tu sesión ha expirado o no tienes una sesión activa.\n\nSerás redirigido al login.',
            'Ir al Login'
        ).subscribe(() => {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        });
        return of(false);
    }

    // Llamar a signinCheck para verificar el estado del usuario
    return this.authSvc.signinCheck().pipe(
        map((res: any) => {
            console.log('IS-ACTIVE GUARD - Respuesta signinCheck:', res);
            
            if (!res.result) {
                // Sesión no válida
                this.dlgsSvc.confirm(
                    'Sesión No Válida',
                    'Tu sesión ha expirado.\n\nSerás redirigido al login.',
                    'Ir al Login'
                ).subscribe(() => {
                    this.authSvc.logout();
                    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                });
                return false;
            }

            const userActive = res.data?.activo;
            const customer = res.data?.customer;
            const customerActive = customer?.activo;
            
            if (customer) {
                if (customerActive !== 1 || userActive !== 1) {
                    if (customerActive !== 1) {
                        this.dlgsSvc.confirm(
                        'Cliente Inactivo',
                        'El cliente asociado a tu cuenta está inactivo. Contacta con el administrador para más información.',
                        'Aceptar'
                    ).subscribe(() => {
                        this.authSvc.logout();
                        this.router.navigate(['/login']);
                    });
                    } else {
                        this.dlgsSvc.confirm(
                            'Cuenta Inactiva',
                            'Tu cuenta está desactivada. Contacta con el administrador para más información.',
                            'Aceptar'
                        ).subscribe(() => {
                            this.authSvc.logout();
                            this.router.navigate(['/login']);
                        });
                    }
                    return false;
                }
            } else {
                // Si no hay cliente asociado (idpartner = 0), solo verificar usuario
                if (userActive !== 1) {
                    this.dlgsSvc.confirm(
                        'Cuenta Inactiva',
                        'Tu cuenta está desactivada.\n\nContacta con el administrador para más información.',
                        'Aceptar'
                    ).subscribe(() => {
                        this.authSvc.logout();
                        this.router.navigate(['/login']);
                    });
                    return false;
                }
            }

            // Usuario (y cliente si existe) activos
            return true;
        }),
        catchError((error) => {
            console.error('IS-ACTIVE GUARD ERROR:', error);
            this.dlgsSvc.confirm(
                'Error de Sesión',
                'Ha ocurrido un error al verificar tu sesión.\n\nSerás redirigido al login.',
                'Ir al Login'
            ).subscribe(() => {
                this.authSvc.logout();
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            });
            return of(false);
        })
    );
  }

}

